import { render } from "./Registrazione.vue?vue&type=template&id=19d912ec&scoped=true"
import script from "./Registrazione.vue?vue&type=script&lang=js"
export * from "./Registrazione.vue?vue&type=script&lang=js"

import "./Registrazione.vue?vue&type=style&index=0&id=19d912ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d912ec"]])

export default __exports__